import { useCallback, useEffect, useRef, useState } from 'react';
import Lenis from 'lenis';
import { Toaster } from 'sonner';
import { AppContext } from './components/shared';
import Nav from './components/Nav';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import Overview from './components/Overview';
import Highlights from './components/Highlights';
import Industries from './components/Industries';
import WhyJoin from './components/WhyJoin';
import Speakers from './components/Speakers';
import PartnersAwards from './components/PartnersAwards';
import Contact from './components/Contact';
import Modal from './components/Modal';

export default function App() {
  const [modal, setModal] = useState(null);
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    if (!lenisRef.current) return;
    if (modal) lenisRef.current.stop();
    else lenisRef.current.start();
  }, [modal]);

  const openModal = useCallback((t) => setModal(t), []);
  const closeModal = useCallback(() => setModal(null), []);
  const scrollToId = useCallback((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (lenisRef.current) lenisRef.current.scrollTo(el, { offset: -64, duration: 1.4 });
    else el.scrollIntoView({ behavior: 'smooth' });
  }, []);

  return (
    <AppContext.Provider value={{ openModal, closeModal, scrollToId }}>
      <div className="grain relative min-h-screen overflow-x-clip bg-ink font-sans text-slate-100">
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <Overview />
          <Highlights />
          <Industries />
          <WhyJoin />
          <Speakers />
          <PartnersAwards />
          <Contact />
        </main>
        <Modal type={modal} onClose={closeModal} />
        <Toaster theme="dark" position="bottom-right" richColors />
      </div>
    </AppContext.Provider>
  );
}
